
<div v-if="pages.length > 0" class="text-center uppercase">
  page
  <component v-for="page in pages" :key="page"
             :is="!isCurrentPage(page) ? 'a' : 'span'"
             @click="goToPage(page)"
             :class="[{ 'bg-primary text-white': isCurrentPage(page) }, 'pl-2 pr-1 cursor-pointer mx-1 rounded cursor-pointer']">
    {{ page }}
  </component>
</div>
